"use strict";

(function () {
	const adpPopup = {
		sPrevious: window.scrollY,
		sDirection: "down",

		init() {
			this.popupInit();
			this.events();
		},

		events() {
			document.addEventListener("click", (e) => {
				if (e.target.closest(".popup-close")) {
					this.closePopup(e);
				}
				if (e.target.closest(".popup-accept")) {
					this.acceptPopup(e);
					this.closePopup(e);
				}
				if (e.target.closest(".age-verification__popup-close")) {
					this.agePopup(e);
					this.closePopup(e);
				}
				if (e.target.closest(".age-verification__button-no")) {
					this.ageDeclined();
				}
			});

			document.addEventListener("keyup", (e) => {
				if (e.key === "Escape") {
					document
						.querySelectorAll('.popup-open[data-esc-close="true"]')
						.forEach((popup) => {
							this.closePopup(popup);
						});
				}

				if (e.key === "F4") {
					document
						.querySelectorAll('.popup-open[data-f4-close="true"]')
						.forEach((popup) => {
							this.closePopup(popup);
						});
				}
			});

			document.addEventListener("click", (e) => {
				if (e.target.closest(".popup-overlay")) {
					document
						.querySelectorAll('.popup-open[data-overlay-close="true"]')
						.forEach((popup) => {
							this.closePopup(popup);
						});
				}
			});
		},

		popupInit() {
			document.addEventListener("scroll", () => {
				const scrollCurrent = window.scrollY;

				if (scrollCurrent > this.sPrevious) {
					this.sDirection = "down";
				} else {
					this.sDirection = "up";
				}

				this.sPrevious = scrollCurrent;
			});

			document.querySelectorAll(".popup").forEach((popup) => {
				if (popup.dataset.openTrigger === "manual") {
					const selector = popup.dataset.openManualSelector;

					if (selector) {
						document.querySelectorAll(selector).forEach((trigger) => {
							trigger.classList.add("popup-trigger");

							trigger.addEventListener("click", (e) => {
								e.preventDefault();

								popup.classList.remove("popup-already-opened");

								this.openPopup(popup);

								if (e.currentTarget.classList.contains("popup")) {
									this.closePopup(selector);
								}
							});
						});
					}
				}

				if (window.location.hash) {
					const submittedForm = popup.querySelector(
						`form[id="${CSS.escape(window.location.hash.slice(1))}"]`
					);
					const hasFormFeedback =
						submittedForm &&
						submittedForm.querySelector(
							'[id^="Newsletter-success--"], [id^="Newsletter-error--"]'
						);

					if (hasFormFeedback) {
						this.openPopup(popup);
						return;
					}
				}

				if (
					!this.isAllowPopup(popup) &&
					!popup.classList.contains("age-verification")
				) {
					return;
				}

				this.openTriggerPopup(popup);
			});

			this.cleanNewsletterFormUrl();
		},

		cleanNewsletterFormUrl() {
			const hasFormFeedback = document.querySelector(
				[
					'[id^="Newsletter-success--"]',
					'[id^="Newsletter-error--"]',
					".newsletter-hero__message--success",
					".newsletter-hero__message--error",
					".newsletter-founders-note__success-message",
					".newsletter-founders-note__message",
					".newsletter3__success-message",
					".newsletter3__message",
				].join(", ")
			);

			if (!hasFormFeedback) return;

			const url = new URL(window.location.href);
			let changed = false;

			["form_type", "customer_posted"].forEach((param) => {
				if (url.searchParams.has(param)) {
					url.searchParams.delete(param);
					changed = true;
				}
			});

			if (url.hash) {
				url.hash = "";
				changed = true;
			}

			if (changed) {
				window.history.replaceState({}, document.title, url.toString());
			}
		},

		openTriggerPopup(popup) {
			const trigger = popup.dataset.openTrigger;

			if (trigger === "none") {
				const ageVerification = this.getCookie(
					"popup-age-" + popup.dataset.id || 0
				);

				if (!ageVerification) this.openPopup(popup);
			}

			if (trigger === "delay") {
				setTimeout(() => {
					this.openPopup(popup);
				}, Number(popup.dataset.openDelayNumber) * 1000);
			}

			if (trigger === "exit") {
				let showExit = true;
				document.addEventListener("mousemove", (e) => {
					const scroll =
						window.pageYOffset || document.documentElement.scrollTop;
					if (e.pageY - scroll < 7 && showExit) {
						this.openPopup(popup);
						showExit = false;
					}
				});
			}

			if (trigger === "scroll") {
				const pointScrollType = popup.dataset.openScrollType;
				const pointScrollPosition = Number(popup.dataset.openScrollPosition);

				document.addEventListener("scroll", () => {
					if (pointScrollType === "px") {
						if (window.scrollY >= pointScrollPosition) {
							this.openPopup(popup);
						}
					}

					if (pointScrollType === "%") {
						if (this.getScrollPercent() >= pointScrollPosition) {
							this.openPopup(popup);
						}
					}
				});
			}

			if (trigger === "accept") {
				const accept = this.getCookie(
					"popup-accept-" + popup.dataset.id || 0
				);

				if (!accept) {
					this.openPopup(popup);
				}
			}
		},

		closeTriggerPopup(popup) {
			const trigger = popup.dataset.closeTrigger;

			if (trigger === "delay") {
				setTimeout(() => {
					this.closePopup(popup);
				}, Number(popup.dataset.closeDelayNumber) * 1000);
			}

			if (trigger === "scroll") {
				const pointScrollType = popup.dataset.closeScrollType;
				const pointScrollPosition = Number(popup.dataset.closeScrollPosition);
				const initScrollPx = Number(popup.dataset.initScrollPx);
				const initScrollPercent = Number(popup.dataset.initScrollPercent);

				document.addEventListener("scroll", () => {
					if (pointScrollType === "px") {
						if (
							this.sDirection === "up" &&
							window.scrollY < initScrollPx - pointScrollPosition
						) {
							this.closePopup(popup);
						}

						if (
							this.sDirection === "down" &&
							window.scrollY >= initScrollPx + pointScrollPosition
						) {
							this.closePopup(popup);
						}
					}

					if (pointScrollType === "%") {
						if (
							this.sDirection === "up" &&
							this.getScrollPercent() <
								initScrollPercent - pointScrollPosition
						) {
							this.closePopup(popup);
						}

						if (
							this.sDirection === "down" &&
							this.getScrollPercent() >=
								initScrollPercent + pointScrollPosition
						) {
							this.closePopup(popup);
						}
					}
				});
			}
		},

		openPopup(el) {
			const popup = this.resolvePopup(el);

			if (popup.matches('[data-body-scroll-disable="true"]')) {
				document.body.classList.add("popup-scroll-hidden");
			}

			const limit =
				parseInt(this.getCookie("popup-" + popup.dataset.id) || 0, 10) + 1;

			this.setCookie("popup-" + popup.dataset.id, limit, {
				expires: popup.dataset.limitLifetime,
			});

			if (popup.classList.contains("popup-open")) {
				return;
			}

			if (popup.classList.contains("popup-already-opened")) {
				return;
			}

			popup.classList.add("popup-open");

			const popupWrap = popup.querySelector(".popup-wrap");
			if (popupWrap) popupWrap.style.opacity = "1";

			popup.dataset.initScrollPx = window.scrollY;
			popup.dataset.initScrollPercent = this.getScrollPercent();

			const animation = popup.dataset.openAnimation;

			this.applyAnimation(popup, animation);

			this.closeTriggerPopup(popup);
		},

		agePopup(e) {
			const el = e instanceof Event ? e.target : e;
			const popup = el.closest(".popup");

			this.setCookie("popup-age-" + popup.dataset.id, 1, {
				expires: 360,
			});
		},

		ageDeclined() {
			document
				.querySelectorAll(".age-verification__question")
				.forEach((el) => el.classList.remove("show"));
			document
				.querySelectorAll(".age-verification__declined")
				.forEach((el) => el.classList.add("show"));
		},

		acceptPopup(e) {
			const el = e instanceof Event ? e.target : e;
			const popup = el.closest(".popup");

			this.setCookie("popup-accept-" + popup.dataset.id, 1, {
				expires: 360,
			});
		},

		closePopup(e) {
			const el = e instanceof Event ? e.target : e;
			let popup;

			if (typeof el === "string") {
				popup = document.querySelector(el)?.closest(".popup");
			} else {
				popup = el.closest?.(".popup") || el;
			}

			if (!popup?.classList?.contains("popup")) {
				return;
			}

			if (!popup.classList.contains("popup-open")) {
				return;
			}

			const animation = popup.dataset.exitAnimation;
			let finished = false;

			const finish = () => {
				if (finished) return;
				finished = true;
				popup.classList.add("popup-already-opened");
				popup.classList.remove("popup-open");
				document.body.classList.remove("popup-scroll-hidden");
				const wrap = popup.querySelector(".popup-wrap");
				if (wrap) {
					wrap.classList.remove("popup-animated", animation);
					wrap.style.opacity = "";
				}
			};

			const wrap = popup.querySelector(".popup-wrap");
			if (!wrap) {
				finish();
				return;
			}

			this.applyAnimation(popup, animation, finish);
			window.setTimeout(finish, 700);
		},

		isAllowPopup(el) {
			const popup = this.resolvePopup(el);

			const limitDisplay = parseInt(popup.dataset.limitDisplay || 0, 10);

			const limitDisplayCookie = parseInt(
				this.getCookie("popup-" + popup.dataset.id)
			);

			if (
				limitDisplay &&
				limitDisplayCookie &&
				limitDisplayCookie >= limitDisplay
			) {
				return;
			}

			return true;
		},

		resolvePopup(el) {
			if (el instanceof Event) {
				return el.target.closest(".popup");
			}
			if (typeof el === "string") {
				return document.querySelector(el)?.closest(".popup");
			}
			return el.closest?.(".popup") || el;
		},

		applyAnimation(el, name, callback) {
			const popup = el.closest(".popup");
			const overlayName =
				typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

			const overlay = popup.nextElementSibling;
			if (overlay?.classList.contains("popup-overlay")) {
				overlay.classList.add("popup-animated", overlayName);
				overlay.addEventListener(
					"animationend",
					() => {
						overlay.classList.remove("popup-animated", overlayName);
					},
					{ once: true }
				);
			}

			const wrap = popup.querySelector(".popup-wrap");
			if (wrap) {
				wrap.classList.add("popup-animated", name);
				wrap.addEventListener(
					"animationend",
					() => {
						wrap.classList.remove("popup-animated", name);

						if (typeof callback === "function") {
							callback();
						}
					},
					{ once: true }
				);
			}
		},

		getCookie(name) {
			const matches = document.cookie.match(
				new RegExp(
					"(?:^|; )" +
						name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
						"=([^;]*)"
				)
			);
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		setCookie(name, value, options) {
			options = options || {};

			options.path = options.hasOwnProperty("path") ? options.path : "/";

			options.expires = parseInt(options.expires, 10);

			if (typeof options.expires == "number" && options.expires) {
				options.expires = new Date().setDate(
					new Date().getDate() + options.expires
				);

				options.expires = new Date(options.expires).toUTCString();
			}

			value = encodeURIComponent(value);

			let updatedCookie = name + "=" + value;

			for (const propName in options) {
				updatedCookie += "; " + propName;
				const propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}

			document.cookie = updatedCookie;
		},

		getScrollPercent() {
			const h = document.documentElement;
			const b = document.body;
			const st = "scrollTop";
			const sh = "scrollHeight";
			return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
		},
	};

	const init = () => {
		adpPopup.init();
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}

	document.addEventListener("shopify:section:load", init);

	document.addEventListener("shopify:section:unload", () => {
		document.body.classList.remove("popup-scroll-hidden");
	});
})();
